// Zjištění výchozího jazyka
import {
  SUPPORTED_LOCALES,
  DEFAULT_LOCALE,
  BROWSER_LOCALE_MAP,
  FOREIGN_LOCALE,
  STORAGE_KEY,
} from "./config.js";

/**
 * @param {unknown} locale
 * @returns {boolean}
 */
export const isSupportedLocale = (locale) => SUPPORTED_LOCALES.includes(locale);

export function readStoredLocale() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isSupportedLocale(stored) ? stored : null;
  } catch {
    return null;
  }
}

export function storeLocale(locale) {
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // Úložiště nedostupné - volba platí jen do obnovení stránky
  }
}

export function detectBrowserLocale() {
  const languages =
    navigator.languages && navigator.languages.length > 0
      ? navigator.languages
      : [navigator.language];

  const primary = languages.find(Boolean);
  if (!primary) return DEFAULT_LOCALE;

  const primarySubtag = primary.toLowerCase().split("-")[0];
  return BROWSER_LOCALE_MAP[primarySubtag] ?? FOREIGN_LOCALE;
}

/** @returns {string} */
export function detectInitialLocale() {
  return readStoredLocale() ?? detectBrowserLocale();
}
